import React from "react";
import "./SeniorManagement.css";

const teamMembers = [
  {
    name: "Srinivasa Rao Katuri",
    title: "Founder, Managing Director & CEO",
    // description:
    //   "accountable for administrative, financial, and risk management operations",
    image: "/assets/images/srini.png",
    borderColor: "cyan",
    textColor: "cyan",
  },
  {
    name: "D V Ramamohan",
    title: "Director – Internal IT and Compliance Audits",
    // description:
    //   "provides direction on the best path of growth for the business",
    image: "/assets/images/DV-Rama-Mohan.png",
    borderColor: "lime",
    textColor: "lime",
  },
  {
    name: "Sreenivasulu Manchikanti",
    title: "Director – Projects & CISO",
    // description:
    //   "assists the Financial Director in all facets of business operations",
    image: "/assets/images/M-Sreenivasulu.png",
    borderColor: "yellow",
    textColor: "yellow",
  },

  {
    name: "Raju UVN",
    title: "Director–Technology",
    // description:
    //   "safeguards the accounts, expenditures, and revenues of the business",
    image: "/assets/images/raju-uvn.png",
    borderColor: "teal",
    textColor: "teal",
  },
];

const SeniorManagement = () => {
  return (
    <>
<section style={{ padding: "80px 20px", textAlign: "center"}}>
  <div
    style={{
      display: "inline-block",
      // padding: "6px 16px",
      backgroundColor: "#ecfdf5",
      color: "#047857",
      borderRadius: "999px",
      fontWeight: 600,
      fontSize: "14px",
      marginBottom: "18px",
    }}
  >
    👥 Senior Management Team
  </div>

  <h2
    style={{
      fontSize: "44px",
      fontWeight: "800",
      color: "#111827",
      marginBottom: "14px",
    }}
  >
   Senior Management Team
  </h2>
  <div
    style={{
      width: "60px",
      height: "4px",
      backgroundColor: "#10b981",
      margin: "0 auto 40px",
      borderRadius: "2px",
    }}
  ></div>
  <p
    style={{
      color: "#4b5563",
      fontSize: "18px",
      marginBottom: "8px",
      maxWidth: "760px",
      marginLeft: "auto",
      marginRight: "auto",
    }}
  >
    Empowering the future of Digital Payments with Vision, Integrity, and Innovation.
  </p>

  <p
    style={{
      color: "#6b7280",
      fontSize: "16px",
      // marginBottom: "30px",
      maxWidth: "700px",
      marginLeft: "auto",
      marginRight: "auto",
    }}
  >
    Meet the minds guiding our mission of secure, inclusive, and scalable digital finance
    solutions.
  </p>


</section>



      <section className="team-section">
        

        <div className="team-grid">
          {teamMembers.map((member, index) => (
            <div className="member-card" key={index}>
              <div className={`hexagon-outer border-${member.borderColor}`}>
                <div className="hexagon-wrapper">
                  <div className="hexagon">
                    <img src={member.image} alt={member.name} />
                  </div>
                </div>
              </div><br></br>
              <h3 className={`member-name text-${member.textColor}`}>{member.name}</h3>
              <p className="member-title">{member.title}</p>
              <p className="member-description">{member.description}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default SeniorManagement;